<template>
  <div class="teaching-schedule-query-clazz-export">
    <div class="body">
      <action-form ref="form"
                   size="mini"
                   label-width="72px"
                   :action="$contextPath('/workspace/manager/teaching/schedule/query/clazz/exportArranges')"
                   :pre-handle-params="preHandleParams"
                   :form-params="form"
                   method="post"
                   target="_blank">
        <el-form-item label="导出学期">
          <el-select v-model="form.semesterId"
                     size="mini"
                     placeholder="请选择导出学期"
                     loading-text="加载中..."
                     :loading="loading"
                     @visible-change="loadSemesters">
            <template v-if="semesters">
              <el-option v-for="semester in semesters"
                         :key="semester.id"
                         :label="semester.name"
                         :value="semester.id"></el-option>
            </template>
          </el-select>
        </el-form-item>
      </action-form>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="handleApply">开始导出</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">关闭窗口</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TeachingScheduleQueryClazzExport',
  props: {
    preHandleParams: {
      type: Function,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      semesters: null,
      form: {
        semesterId: ''
      },
      committing: false
    }
  },
  methods: {
    loadSemesters (popperVisible) {
      if (popperVisible && !this.loading && !this.semesters) {
        this.loading = true
        this.$ajax({
          url: '/workspace/manager/portal/data/select/semesters',
          method: 'post'
        }).then(response => {
          if (response.data) {
            this.semesters = response.data['semesters'] || []
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleApply () {
      if (!this.form.semesterId) {
        this.$message.warning('请选择导出学期')
        return
      }
      let form = this.$refs.form
      if (form) {
        this.committing = true
        form.submit(() => {
          this.committing = false
        })
      }
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          this.form[key] = ''
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .teaching-schedule-query-clazz-export {
    & > .body {
      padding: 20px 30px 20px 15px;
      .el-form {
        .el-form-item {
          &:last-child {
            margin-bottom: 0;
          }
          .el-form-item__label {
            font-size: 12px;
          }
          .el-form-item__content {
            .el-select {
              width: 100%;
            }
          }
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
